import React from "react";
import ChartVariables from "./chartVariables";
export default function ChartVariablesContainer({ trackedItemInfo }) {
    return React.createElement(ChartVariables, { chartVariables: trackedItemInfo });
}
